// Shared helpers for the membership pages (talks to src/api/membership.php).

export const MEMBER_API = "https://pos.mzprotrading.com/api/membership.php?";
export const REGISTER_URL = "https://pos.mzprotrading.com/member/register";
export const OWNER_USERNAME = "MingZe";

export const isOwner = () => sessionStorage.getItem('username') === OWNER_USERNAME;

// Fetches a login token for membership.php. Called from Login.jsx after a successful login.
export const fetchMemberToken = (username, password) => {
  const body = new URLSearchParams();
  body.append("username", username);
  body.append("password", password);
  return fetch(MEMBER_API + 'mode=auth-token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  })
    .then(response => response.json())
    .then(json => {
      if (json.success == 1) {
        sessionStorage.setItem('membertoken', json.token);
        sessionStorage.setItem('username', json.username);
      }
    })
    .catch(() => { });
};

// POST to membership.php. `data` is a plain object, or a FormData for uploads.
export const memberPost = (mode, data = {}) => {
  let body;
  let headers = { 'Accept': 'application/json' };
  if (data instanceof FormData) {
    body = data;
    body.append("token", sessionStorage.getItem('membertoken') || '');
  } else {
    body = new URLSearchParams();
    Object.keys(data).forEach(key => body.append(key, data[key] == null ? '' : data[key]));
    body.append("token", sessionStorage.getItem('membertoken') || '');
    headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  return fetch(MEMBER_API + 'mode=' + mode, { method: 'POST', headers, body })
    .then(response => response.json())
    .catch(() => ({ success: 0, message: 'Network error, please try again' }));
};

export const uploadImage = (file) => {
  const form = new FormData();
  form.append("image", file);
  return memberPost('upload-image', form);
};

// 60123456789 -> +60 12-345 6789 style for display
export const formatPhone = (phone) => {
  if (!phone) return '';
  if (phone.indexOf('60') === 0) return '+60 ' + phone.slice(2);
  if (phone.indexOf('65') === 0) return '+65 ' + phone.slice(2);
  return '+' + phone;
};

export const formatDate = (unix) => {
  if (!unix || unix == 0) return '-';
  const d = new Date(parseInt(unix, 10) * 1000);
  return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear();
};

export const formatDateTime = (unix) => {
  if (!unix || unix == 0) return '-';
  const d = new Date(parseInt(unix, 10) * 1000);
  return formatDate(unix) + ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
};

export const money = (value) => 'RM ' + (parseFloat(value) || 0).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const EMOJIS = ['😀', '😊', '😍', '🥳', '🎉', '🎂', '🎁', '🔥', '⭐', '💯', '👍', '🙏', '❤️', '📱', '💰', '🛍️', '🏷️', '⚡', '✅', '📢', '👉', '🎊', '😎', '🤩'];
